import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy, RouterModule } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  StreamingMedia,
  StreamingVideoOptions,
} from "@ionic-native/streaming-media/ngx";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { Camera } from "@ionic-native/camera/ngx";
import { Network } from "@ionic-native/network/ngx";
import { IonicStorageModule } from "@ionic/storage";
import { HttpClientModule } from "@angular/common/http";
import { AndroidPermissions } from "@ionic-native/android-permissions/ngx";
import { UniqueDeviceID } from "@ionic-native/unique-device-id/ngx";
// import { FCM } from '@ionic-native/fcm/ngx';
import { MAT_DATE_LOCALE } from "@angular/material/core";
// import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { Market } from "@ionic-native/market/ngx";
import { MatIconModule } from "@angular/material/icon";
import { Chooser } from "@ionic-native/chooser/ngx";
import { File } from "@ionic-native/file/ngx";
import { FileTransfer } from "@ionic-native/file-transfer/ngx";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { BackgroundMode } from "@ionic-native/background-mode/ngx";
import { Push } from "@ionic-native/push/ngx";
import { Zoom } from "@ionic-native/zoom/ngx";
import { AppointmentFormPage } from "./appointment-form/appointment-form.page";
//import { FlexLayoutModule } from '@angular/flex-layout';
//import {MatToolbarModule} from '@angular/material/toolbar';
//import {MatSidenavModule} from '@angular/material/sidenav';
@NgModule({
  declarations: [AppComponent,],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxMaterialTimepickerModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    MatIconModule,
    
    
  ],
  providers: [
    StatusBar,
    SplashScreen,
    StreamingMedia,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    Camera,
    Network,
    AndroidPermissions,
    UniqueDeviceID,
    AppVersion,
    Market,
    Chooser,
    File,
    FileTransfer,
    FileOpener,
    BackgroundMode,
    { provide: MAT_DATE_LOCALE, useValue: "en-IN" },
    Push,
    Zoom,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
